import * as React from 'react';
import Svg, {Path} from 'react-native-svg';
import Styles from 'src/components/Styles';

function BlockedSnackUsers() {
  return (
    <Svg width={24} height={24} viewBox="0 0 24 24" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-9.41L14.59 8 16 9.41 13.41 12 16 14.59 14.59 16 12 13.41 9.41 16 8 14.59 10.59 12 8 9.41 9.41 8 12 10.59z"
        fill={Styles.Colors.PayNew.black01}
      />
    </Svg>
  );
}

const BlockedSnackUsersIcon = React.memo(BlockedSnackUsers);

export default BlockedSnackUsersIcon;
